import React, { Component } from "react";
import { Base } from "zina-dogi-react";
import { OpenRunVsPendencyReport } from "../components";


class OpenRunVsPendencyReportContainer extends Component {
    render() {
        const { extraProps } = this.props;
        const base_op = {
            className: "report",
            title: "Open runs vs pendency report",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Open runs vs pendency report" }],
            extraProps,
            loading: false
        };
        return (
            <Base {...base_op}>
                <OpenRunVsPendencyReport />
            </Base>
        );
    }
}

export default OpenRunVsPendencyReportContainer;
